<template>
  <div class="">
    <div class="table-page-search-wrapper">
      <a-row :gutter="12" style="margin:16px 25px;">
        <a-col class="a-large-form" >
          <a-form-item label="" style="margin-bottom:0px">
            <a-input placeholder="请输入直播名称" style="width:100%" v-model="queryParam.name"></a-input>
          </a-form-item>
        </a-col>
        <a-button @click="searchQuery" type="primary" style="margin-left:5px;vertical-align: middle;">筛选</a-button>

        <a-col style="float:right;">
          <span style="margin-bottom:0px" class="table-page-search-submitButtons">
            <!-- <a-button @click="courseHoursCreate()" type="primary" icon="plus" style="margin-left:8px;">新增课时</a-button> -->
            <a-button @click="courseChapterCreate()" type="primary" icon="plus" style="margin-left:8px;">新增章节</a-button>
          </span>
        </a-col>
      </a-row>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :defaultExpandAllRows="true"
        v-if="!loading"
        :loading="loading">
        <!--  -->
        <span slot="action" slot-scope="text, record">
          <span v-if="record.children">
            <a @click="courseChapterEdite(record.id)" v-if="record.children" >编辑章节</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除吗?" @confirm="() => courseChapterDel(record.id)">
              <a>删除章节</a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a @click="courseHoursCreate(record.id)" v-if="record.children">新增课时</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定下架吗?" v-if="record.chapterStatus==1" @confirm="() => chapterShelf(record.id)">
              <a>下架</a>
            </a-popconfirm>

            <a-popconfirm title="确定上架吗?" v-else @confirm="() => chapterShelf(record.id)">
              <a>上架</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a @click="courseHoursEdite(record)" >编辑</a>
            <a-divider type="vertical" />

            <a-popconfirm title="确定要删除吗?" @confirm="() => courseHoursDel(record)">
              <a >删除</a>
            </a-popconfirm>
            <a-divider type="vertical" />

            <a-popconfirm title="确定下架吗?" v-if="record.chStatus==1" @confirm="() => courseHourShelf(record.id)">
              <a>下架</a>
            </a-popconfirm>

            <a-popconfirm title="确定上架吗?" v-else @confirm="() => courseHourShelf(record.id)">
              <a>上架</a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a @click="onliveInfo(record)" >直播间信息</a>
            <a-divider type="vertical" />
            <a @click="gotoOnline(record)" >去直播</a>
          </span>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  import { handleFullScreen } from '@/utils/util.js'

  import { delLiveCourseHours, delLiveCourseChapter, liveCourseHoursShelf, liveCourseChapterShelf } from '@/api/api'

  export default {
    name: 'ClassHourManage',
    components: {

    },
    mixins: [JeecgListMixin],
    data() {
      return {
        firstIsNotLoad: true,
        courseId: '',
        queryParam: {
          id: '',
          name: ''
        },
        loading: false,
        visible: false,
        description: '课时管理',
        url: {
          list: '/live/liveCourseChapter/list',
          delete: '/live/liveCourseChapter/delete'
          // deleteBatch: "/course/elinkxCourse/deleteBatch",
          // exportXlsUrl: "course/elinkxCourse/exportXls",
          // importExcelUrl: "course/elinkxCourse/importExcel",
        },
        columns: [
          {
            title: '直播名称',
            align: 'left',
            dataIndex: 'chapterName',
            customRender: (text, row, index) => {
              if (row.children) {
                return row.chapterName + '(共' + row.children.length + '节课时)'
              } else {
                return row.chName
              }
            },
            width: 300
          },
          {
            title: '开播时间',
            align: 'center',
            dataIndex: 'chStartDate',
            width: 200
          },
          {
            title: '直播状态',
            align: 'center',
            dataIndex: 'chStatus',
            width: 80,
            customRender: (text, row, index) => {
              if (row.chLiveState == 0) {
                return <span><i style="color:grey;font-size:15px;margin-right:2px">•</i>未开始</span>
              } else if (row.chLiveState == 1) {
                return <span><i style="color:green;font-size:15px;margin-right:2px">•</i>直播中</span>
              } else if (row.chLiveState == 2) {
                return <span><i style="color:red;font-size:15px;margin-right:2px">•</i>已结束</span>
              } else if (row.chLiveState == 3) {
                return <span><i style="color:red;font-size:15px;margin-right:2px">•</i>直播回放</span>
              } else {
                return <span>-</span>
              }
              // return (<span style='color:#333;font-size:12px;'>{row.status==0?'已结束':<span style="color:#71818E">已下架</span>}</span>)
            }
          },
          {
            title: '状态',
            align: 'center',
            dataIndex: 'chapterStatus',
            width: 100,
            customRender: (text, row, index) => {
              if (row.children) {
                return (<span style='color:#333;font-size:12px;'>{row.chapterStatus == 1 ? '已上架' : <span style="color:#71818E">已下架</span>}</span>)
              } else {
                return (<span style='color:#333;font-size:12px;'>{row.chStatus == 1 ? '已上架' : <span style="color:#71818E">已下架</span>}</span>)
              }
            }
          },
          {
            title: '序号',
            align: 'center',
            dataIndex: 'chOrder',
            width: 100,
            customRender: (text, row, index) => {
              if (row.children) {
                return row.chapterOrder
              } else {
                return row.chOrder
              }
            }
            
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
            width: 300
          }
        ],
        dataSource: [

        ]
      }
    },

    created() {
      this.queryParam.id = this.$route.query.courseId
      this.loadData()
      // alert(this.queryParam.courseId)
      // console.log("123");
    },

    methods: {

      gotoOnline(item) {
        handleFullScreen()
        this.$router.push({ path: '/onlineVideoTeacher/onlineVideoRoom?courseId=' + this.queryParam.id + '&id=' + item.id })
      },
      // 直播间信息
      onliveInfo(record) {
        this.$router.push({ path: '/onlineVideo/onlineVideoInfo?chId=' + record.id })
      },
      // 新增章节
      courseChapterCreate() {
        this.$router.push({ path: '/onlineVideo/onlineVideoChapterCreate?courseId=' + this.queryParam.id })
      },

      // 删除章节
      courseChapterDel(chapterIdPram) {
        delLiveCourseChapter({ id: chapterIdPram }).then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      },

      // 编辑章节
      courseChapterEdite(chapterIdPram) {
        this.$router.push({ path: '/onlineVideo/onlineVideoChapterCreate?chapterId=' + chapterIdPram + '&courseId=' + this.queryParam.id })
      },
      // 课时上下架
      chapterShelf(chapterIdParam) {
        liveCourseChapterShelf({ id: chapterIdParam }).then((res) => {
          if (res.success == true) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      },

      // 创建课时
      courseHoursCreate(id) {
        // this.visible = true;
        // this.$refs.courseTypeSelectModal.add(id)
        this.$router.push({ path: '/onlineVideo/onlineVideoHourCreate?chapterId=' + id + '&courseId=' + this.queryParam.id })
      },

      // 编辑课时
      courseHoursEdite(item) {
        this.$router.push({ path: '/onlineVideo/onlineVideoHourCreate?id=' + item.id + '&courseId=' + this.queryParam.id + '&chapterId=' + item.chapterId })

        // if(item.chType=="1"){
        //   this.$router.push({ path:'/myCourse/pictureBookCreate?courseId='+this.queryParam.courseId+"&id="+item.id+"&chapterId="+item.chapterId});
        // }else if(item.chType=="2"){
        //   this.$router.push({ path:'/myCourse/videoCreate?courseId='+this.queryParam.courseId+"&id="+item.id+"&chapterId="+item.chapterId});
        // }
        // else if(item.chType=="3"){
        //   this.$router.push({ path:'/myCourse/imageTextCreate?courseId='+this.queryParam.courseId+"&id="+item.id+"&chapterId="+item.chapterId});
        // }
        // else if(item.chType=="4"){
        //   this.$router.push({ path:'/myCourse/audioCreate?courseId='+this.queryParam.courseId+"&id="+item.id+"&chapterId="+item.chapterId});
        // }
        // else if(item.chType=="5"){
        //   this.$router.push({ path:'/myCourse/gameHourCreate?courseId='+this.queryParam.courseId+"&id="+item.id+"&chapterId="+item.chapterId});
        // }
      },

      // 删除课时
      courseHoursDel(item) {
        delLiveCourseHours({ id: item.id }).then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      },
      // 课时上下架
      courseHourShelf(idParam) {
        liveCourseHoursShelf({ id: idParam }).then((res) => {
          if (res.success == true) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      }

    }
  }
</script>

<style scoped>

</style>
